import styled from "styled-components";

// ─── Main Container ────────────────────────────────────

export const MobilePreview = styled.div`
    width: 420px;
    height: 750px;
    background-color: #f8f9fa;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    border: 1px solid #e0e0e0;
    position: relative;
    display: flex;
    flex-direction: column;

    @media (max-width: 1200px) {
        width: 350px;
        height: 650px;
    }

    @media (max-width: 992px) {
        width: 100%;
        max-width: 420px;
        height: 650px;
        margin: 0 auto;
    }

    @media (max-width: 576px) {
        width: 100%;
        height: 550px;
        border-radius: 8px;
    }
`;

export const PreviewHeader = styled.div<{ mainColor: string; primaryColor?: string }>`
    background-color: ${({ primaryColor, mainColor }) =>
        primaryColor || mainColor};
    color: white;
    padding: 12px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
`;

export const HeaderLogo = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    font-size: 14px;
`;

export const HeaderRight = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 10px;
`;

export const LanguageSelector = styled.div`
    background-color: rgba(255, 255, 255, 0.2);
    padding: 3px 8px;
    border-radius: 4px;
    font-size: 10px;
    display: flex;
    align-items: center;
    gap: 3px;
`;

export const TableBadge = styled.div`
    background-color: rgba(255, 255, 255, 0.25);
    padding: 3px 8px;
    border-radius: 4px;
    font-size: 10px;
`;

// ─── Banner ─────────────────────────────────────────────

export const BannerSliderContainer = styled.div<{ bannerEnabled: boolean }>`
    display: ${({ bannerEnabled }) => (bannerEnabled ? "block" : "none")};
    height: 160px;
    min-height: 160px;
    flex-shrink: 0;
    position: relative;
    overflow: hidden;
    transition: height 0.3s ease;
`;

export const BannerSlide = styled.div<{
    bannerImage: string;
    isActive: boolean;
    direction: number;
}>`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${({ bannerImage }) =>
        `linear-gradient(to bottom, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.7) 100%), url('${bannerImage}')`};
    background-size: cover;
    background-position: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 18px;
    color: white;
    opacity: ${({ isActive }) => (isActive ? 1 : 0)};
    transform: translateX(
        ${({ isActive, direction }) => (isActive ? 0 : direction * 100)}%
    );
    transition: all 0.4s ease;
`;

export const SliderControls = styled.div`
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 6px;
    z-index: 10;
`;

export const SliderDot = styled.button<{ isActive: boolean; mainColor: string }>`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    border: none;
    background-color: ${({ isActive, mainColor }) =>
        isActive ? mainColor : "rgba(255, 255, 255, 0.5)"};
    cursor: pointer;
    transition: all 0.2s ease;
    padding: 0;

    &:hover {
        background-color: ${({ isActive, mainColor }) =>
            isActive ? mainColor : "rgba(255, 255, 255, 0.8)"};
    }
`;

export const SliderArrow = styled.button<{ direction: "left" | "right" }>`
    position: absolute;
    top: 50%;
    ${({ direction }) => (direction === "left" ? "left: 10px" : "right: 10px")};
    transform: translateY(-50%);
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: none;
    background-color: rgba(0, 0, 0, 0.4);
    color: white;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: rgba(0, 0, 0, 0.6);
    }

    svg {
        width: 16px;
        height: 16px;
    }
`;

export const BannerContent = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
`;

export const BannerText = styled.div`
    flex: 1;
`;

export const PreviewTitle = styled.h3<{ color?: string }>`
    font-size: 18px;
    margin: 0 0 5px 0;
    font-weight: 700;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
    color: ${({ color }) => color || "#ffffff"};
`;

export const PreviewSubtitle = styled.p<{ color?: string }>`
    font-size: 12px;
    margin: 0;
    opacity: 0.95;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
    color: ${({ color }) => color || "#ffffff"};
`;

// ─── Content Sections ────────────────────────────────────

export const PreviewContent = styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 15px;
`;

export const PreviewSection = styled.div`
    background-color: white;
    border-radius: 10px;
    padding: 10px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
`;

export const PreviewSectionTitle = styled.h4<{ mainColor?: string }>`
    font-size: 13px;
    color: #333;
    margin: 0 0 10px 0;
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 600;
`;

// ─── Offers ──────────────────────────────────────────────

export const OffersContainer = styled.div`
    display: flex;
    gap: 10px;
    overflow-x: auto;
    padding-bottom: 5px;

    &::-webkit-scrollbar {
        height: 3px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #ddd;
        border-radius: 3px;
    }
`;

export const OfferCard = styled.div<{ mainColor: string }>`
    min-width: 130px;
    max-width: 130px;
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    border: 1px solid #eee;
    flex-shrink: 0;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
`;

export const OfferCardImage = styled.div`
    width: 100%;
    height: 80px;
    overflow: hidden;
    background-color: #f0f0f0;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

export const OfferCardBody = styled.div`
    padding: 6px 8px 8px;
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const OfferCardTitle = styled.span`
    font-size: 10px;
    font-weight: 600;
    color: #333;
    line-height: 1.3;
`;

export const OfferCardDescription = styled.span`
    font-size: 8px;
    color: #666;
    line-height: 1.3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const OfferDiscount = styled.span<{
    mainColor: string;
    secondaryColor?: string;
}>`
    font-size: 9px;
    font-weight: 700;
    color: white;
    background-color: ${({ secondaryColor, mainColor }) =>
        secondaryColor || mainColor};
    border-radius: 4px;
    padding: 1px 5px;
    align-self: flex-start;
    margin-top: 2px;
`;

// ─── Actions ─────────────────────────────────────────────

export const ActionsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
`;

export const ActionCard = styled.div`
    background-color: #f5f5f5;
    border-radius: 10px;
    padding: 16px 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    text-align: center;
`;

export const ActionIconCircle = styled.div<{ bgColor: string }>`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: ${({ bgColor }) => bgColor};
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 2px;

    svg {
        width: 22px;
        height: 22px;
        fill: white;
    }
`;

export const ActionTitle = styled.span`
    font-size: 11px;
    font-weight: 600;
    color: #333;
    line-height: 1.3;
`;

export const ActionDescription = styled.span`
    font-size: 8px;
    color: #888;
    line-height: 1.3;
`;

export const SectionDivider = styled.div<{ mainColor: string }>`
    height: 2px;
    background-color: ${({ mainColor }) => mainColor};
    margin: 0 0 12px 0;
    border-radius: 1px;
`;

// ─── Advertising ────────────────────────────────────────

export const AdCard = styled.div`
    min-width: 160px;
    max-width: 160px;
    height: 100px;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    flex-shrink: 0;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    background-color: #f0f0f0;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

export const AdBadge = styled.span<{ mainColor: string }>`
    position: absolute;
    top: 6px;
    right: 6px;
    background-color: ${({ mainColor }) => mainColor};
    color: white;
    font-size: 7px;
    font-weight: 700;
    padding: 2px 6px;
    border-radius: 3px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
`;

// ─── Order Section ───────────────────────────────────────

export const OrderSectionContainer = styled.div`
    background-color: white;
    border-radius: 10px;
    padding: 10px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
`;

export const OrderItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 0;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
        border-bottom: none;
    }
`;

export const OrderItemInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const OrderItemImage = styled.div`
    width: 32px;
    height: 32px;
    background-color: #f5f5f5;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
`;

export const OrderItemDetails = styled.div`
    display: flex;
    flex-direction: column;
`;

export const OrderItemName = styled.span`
    font-size: 10px;
    font-weight: 500;
    color: #333;
`;

export const OrderItemQty = styled.span`
    font-size: 8px;
    color: #999;
`;

export const OrderItemPrice = styled.span<{ mainColor: string }>`
    font-size: 10px;
    font-weight: 600;
    color: ${({ mainColor }) => mainColor};
`;

export const OrderTotal = styled.div<{ mainColor: string }>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 8px;
    margin-top: 5px;
    border-top: 1px dashed ${({ mainColor }) => mainColor}50;
`;

export const TotalLabel = styled.span`
    font-size: 11px;
    font-weight: 600;
    color: #333;
`;

export const TotalAmount = styled.span<{ mainColor: string }>`
    font-size: 13px;
    font-weight: 700;
    color: ${({ mainColor }) => mainColor};
`;

// ─── Order Stepper ──────────────────────────────────────

export const StepperContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    padding: 0 4px;
`;

export const StepperStep = styled.div<{
    isActive: boolean;
    isCompleted: boolean;
    mainColor: string;
}>`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    flex: 1;
    position: relative;
`;

export const StepperDot = styled.div<{
    isActive: boolean;
    isCompleted: boolean;
    mainColor: string;
}>`
    width: ${({ isActive }) => (isActive ? "22px" : "16px")};
    height: ${({ isActive }) => (isActive ? "22px" : "16px")};
    border-radius: 50%;
    background-color: ${({ isActive, isCompleted, mainColor }) =>
        isActive || isCompleted ? mainColor : "#ddd"};
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    z-index: 2;

    svg {
        width: 10px;
        height: 10px;
        fill: white;
    }
`;

export const StepperLabel = styled.span<{
    isActive: boolean;
    isCompleted: boolean;
    mainColor: string;
}>`
    font-size: 7px;
    font-weight: ${({ isActive }) => (isActive ? "700" : "500")};
    color: ${({ isActive, isCompleted, mainColor }) =>
        isActive || isCompleted ? mainColor : "#999"};
    text-align: center;
    white-space: nowrap;
`;

export const StepperLine = styled.div<{ isCompleted: boolean; mainColor: string }>`
    position: absolute;
    top: ${({ isCompleted }) => (isCompleted ? "8px" : "8px")};
    left: 50%;
    width: 100%;
    height: 2px;
    background-color: ${({ isCompleted, mainColor }) =>
        isCompleted ? mainColor : "#ddd"};
    z-index: 1;
`;

export const OrderInfoCard = styled.div<{ mainColor: string; primaryColor?: string }>`
    background-color: ${({ primaryColor, mainColor }) =>
        `${primaryColor || mainColor}10`};
    border: 1px solid
        ${({ primaryColor, mainColor }) => `${primaryColor || mainColor}30`};
    border-radius: 8px;
    padding: 8px 10px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const OrderInfoLeft = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const OrderInfoLabel = styled.span`
    font-size: 7px;
    color: #999;
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;

export const OrderInfoValue = styled.span`
    font-size: 11px;
    font-weight: 600;
    color: #333;
`;

export const StatusBadge = styled.span<{ mainColor: string; primaryColor?: string }>`
    font-size: 8px;
    font-weight: 600;
    color: white;
    background-color: ${({ primaryColor, mainColor }) =>
        primaryColor || mainColor};
    padding: 3px 8px;
    border-radius: 10px;
`;

export const NoOrderContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px 10px;
    gap: 8px;
    color: #999;
`;

export const NoOrderIcon = styled.div`
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: #f5f5f5;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 24px;
        height: 24px;
        fill: #ccc;
    }
`;

export const NoOrderText = styled.span`
    font-size: 12px;
    font-weight: 600;
    color: #666;
`;

export const NoOrderSubtext = styled.span`
    font-size: 9px;
    color: #999;
    text-align: center;
`;

// ─── Rich Footer ────────────────────────────────────────

export const RichFooter = styled.div`
    display: flex;
    flex-direction: column;
`;

export const FooterMainSection = styled.div`
    background-color: white;
    color: #333;
    padding: 10px 12px;
    font-size: 8px;
`;

export const FooterColumns = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 8px;
`;

export const FooterColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 3px;
`;

export const FooterColumnTitle = styled.span`
    font-size: 8px;
    font-weight: 700;
    margin-bottom: 2px;
    color: #333;
`;

export const FooterRestaurantName = styled.span`
    font-size: 10px;
    font-weight: 700;
    color: #333;
`;

export const FooterDescription = styled.span`
    font-size: 7px;
    color: #666;
    line-height: 1.3;
`;

export const FooterLegalLink = styled.span`
    font-size: 7px;
    color: #666;
    cursor: pointer;
    &:hover {
        color: #333;
    }
`;

export const FooterSocialIcons = styled.div`
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
    margin-top: 2px;
`;

export const FooterSocialIcon = styled.div<{ accentColor: string }>`
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: ${({ accentColor }) => accentColor};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: opacity 0.2s;
    &:hover {
        opacity: 0.8;
    }
    svg {
        width: 10px;
        height: 10px;
        fill: white;
    }
`;

export const FooterCopyrightBar = styled.div<{ primaryColor: string }>`
    background-color: ${({ primaryColor }) => primaryColor};
    color: white;
    padding: 6px 12px;
    text-align: center;
    font-size: 6px;
`;

// ─── Payment Popup ────────────────────────────────────

export const PaymentPopupOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
`;

export const PaymentPopupModal = styled.div`
    background-color: white;
    border-radius: 16px;
    width: 100%;
    max-height: 85%;
    overflow-y: auto;
    padding: 16px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2);
`;

export const PaymentPopupHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
`;

export const PaymentPopupTitle = styled.h3`
    font-size: 14px;
    font-weight: 700;
    color: #333;
    margin: 0;
`;

export const PaymentAmountCard = styled.div<{ mainColor: string }>`
    background-color: ${({ mainColor }) => `${mainColor}10`};
    border: 1px solid ${({ mainColor }) => `${mainColor}30`};
    border-radius: 10px;
    padding: 8px 12px;
    margin-bottom: 10px;
    text-align: center;
`;

export const PaymentAmountLabel = styled.span`
    font-size: 7px;
    color: #999;
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;

export const PaymentAmountValue = styled.span<{ mainColor: string }>`
    font-size: 16px;
    font-weight: 700;
    color: ${({ mainColor }) => mainColor};
    display: block;
    margin-top: 2px;
`;

export const PaymentPopupSubtitle = styled.p`
    font-size: 9px;
    color: #666;
    margin: 0 0 8px 0;
`;

export const PaymentMethodRow = styled.div<{ isSelected: boolean; mainColor: string }>`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 10px;
    border-radius: 10px;
    border: 1.5px solid
        ${({ isSelected, mainColor }) => (isSelected ? mainColor : "#eee")};
    background-color: ${({ isSelected, mainColor }) =>
        isSelected ? `${mainColor}08` : "#fff"};
    margin-bottom: 6px;
    cursor: pointer;
    transition: all 0.15s ease;
    &:last-child {
        margin-bottom: 0;
    }
`;

export const PaymentMethodIcon = styled.div<{ mainColor: string }>`
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: ${({ mainColor }) => `${mainColor}15`};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    svg {
        width: 15px;
        height: 15px;
        fill: ${({ mainColor }) => mainColor};
    }
`;

export const PaymentMethodInfo = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
`;

export const PaymentMethodTitle = styled.span`
    font-size: 10px;
    font-weight: 600;
    color: #333;
`;

export const PaymentMethodDesc = styled.span`
    font-size: 7.5px;
    color: #888;
`;

export const PaymentRadio = styled.div<{ isSelected: boolean; mainColor: string }>`
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 2px solid
        ${({ isSelected, mainColor }) => (isSelected ? mainColor : "#ccc")};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    &::after {
        content: "";
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: ${({ isSelected, mainColor }) =>
            isSelected ? mainColor : "transparent"};
    }
`;

export const PaymentOptionsSection = styled.div`
    margin-top: 10px;
    padding-top: 8px;
    border-top: 1px solid #f0f0f0;
`;

export const PaymentOptionsLabel = styled.span`
    font-size: 8px;
    font-weight: 700;
    color: #999;
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;

export const PaymentToggleRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 6px;
`;

export const PaymentToggleInfo = styled.div`
    display: flex;
    flex-direction: column;
`;

export const PaymentToggleTitle = styled.span`
    font-size: 10px;
    font-weight: 600;
    color: #333;
`;

export const PaymentToggleDesc = styled.span`
    font-size: 7.5px;
    color: #888;
`;

export const PaymentToggleSwitch = styled.div<{ isOn: boolean; mainColor: string }>`
    width: 32px;
    height: 18px;
    border-radius: 9px;
    background-color: ${({ isOn, mainColor }) => (isOn ? mainColor : "#ddd")};
    position: relative;
    cursor: pointer;
    transition: background-color 0.2s ease;
    &::after {
        content: "";
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background-color: white;
        position: absolute;
        top: 2px;
        left: ${({ isOn }) => (isOn ? "16px" : "2px")};
        transition: left 0.2s ease;
    }
`;

export const PaymentPopupActionBtn = styled.button<{ mainColor: string }>`
    width: 100%;
    padding: 10px;
    border: none;
    border-radius: 10px;
    background-color: ${({ mainColor }) => mainColor};
    color: white;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    margin-top: 12px;
    transition: opacity 0.2s ease;
    &:hover {
        opacity: 0.9;
    }
`;

export const PaymentPopupBackBtn = styled.button`
    width: 100%;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 10px;
    background-color: white;
    color: #666;
    font-size: 10px;
    font-weight: 500;
    cursor: pointer;
    margin-top: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    &:hover {
        background-color: #f9f9f9;
    }
`;

// ─── Server Call Popup styled components ──────────────────
export const ServerCallPopupOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
`;

export const ServerCallPopupModal = styled.div`
    background-color: white;
    border-radius: 16px;
    width: 100%;
    max-height: 85%;
    overflow-y: auto;
    padding: 16px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2);
`;

export const ServerCallPopupHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
`;

export const ServerCallPopupTitle = styled.h3`
    font-size: 14px;
    font-weight: 700;
    color: #333;
    margin: 0;
`;

export const ServerCallPopupClose = styled.button`
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: none;
    background-color: #f0f0f0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &:hover {
        background-color: #e0e0e0;
    }
    svg {
        width: 12px;
        height: 12px;
        fill: #666;
    }
`;

export const ServerCallPopupSubtitle = styled.p`
    font-size: 9px;
    color: #666;
    margin: 0 0 10px 0;
`;

export const ServerCallOptionsGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    margin-bottom: 12px;
`;

export const ServerCallOptionBtn = styled.div<{ mainColor: string }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 12px 8px;
    border-radius: 10px;
    border: 1.5px solid #eee;
    background-color: #fff;
    cursor: pointer;
    transition: all 0.15s ease;

    &:hover {
        border-color: ${({ mainColor }) => mainColor};
        background-color: ${({ mainColor }) => `${mainColor}08`};
    }
`;

export const ServerCallOptionIcon = styled.div<{ mainColor: string }>`
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background-color: ${({ mainColor }) => `${mainColor}15`};
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
        width: 16px;
        height: 16px;
        fill: ${({ mainColor }) => mainColor};
    }
`;

export const ServerCallOptionLabel = styled.span`
    font-size: 8px;
    font-weight: 500;
    color: #333;
    text-align: center;
    line-height: 1.2;
`;

export const ServerCallCustomSection = styled.div`
    margin-bottom: 12px;
`;

export const ServerCallCustomLabel = styled.p`
    font-size: 9px;
    font-weight: 600;
    color: #333;
    margin: 0 0 6px 0;
`;

export const ServerCallTextarea = styled.div`
    width: 100%;
    min-height: 50px;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 8px;
    font-size: 8px;
    color: #999;
    background-color: #fafafa;
`;

export const ServerCallSubmitBtn = styled.button<{ mainColor: string }>`
    width: 100%;
    padding: 10px;
    border: none;
    border-radius: 10px;
    background-color: ${({ mainColor }) => mainColor};
    color: white;
    font-size: 10px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    transition: opacity 0.2s ease;
    &:hover {
        opacity: 0.9;
    }
`;
